import React from "react";
import PageTitle from "../../global/components/PageTitle";
import { Link, Navigate } from "react-router-dom";
import useGetAllChangesForAdmin from "./queries/useGetAllChangesForAdmin";
import ChangesDataTable from "./components/ChangesDataTable";
import { Typography, Box } from "@mui/material";
import PendingProgress from "./components/PendingProgress";

const AdminDashboard = () => {
  const { data: changes, isError } = useGetAllChangesForAdmin();

  if (isError) return <Navigate to="/login" />;

  if (!changes) return <h1>Keine Änderungen</h1>;

  const filteredChanges = changes.filter((change) => change?.status.toString() === "P")

  return (
    <>
      <Typography variant="h5" sx={{ paddingVertical: 3 }}>
        Pending
      </Typography>
      <PendingProgress value={filteredChanges.length / changes.length} validationMessage={`${filteredChanges.length} Pending von ${changes.length} Aenderungen noch uebrig`} />
      <ChangesDataTable
        changes={filteredChanges}
      />
    </>
  );
};

export default AdminDashboard;
